import { createStore } from "vuex";

const store = createStore({
	strict: true,
	state: {
		token: localStorage.getItem("rmp_token"),
		user: JSON.parse(localStorage.getItem("rmp_user")) || {
			uid: null,
			profile_uid: null,
			email: null,
			username: null,
			first_name: null,
			last_name: null,
			date_of_birth: null,
			is_mentor: false,
			is_mentee: false,
			is_rfc: false,
			profile_url: null,
			is_blocked: false,
			is_verified: true,
		},
		show_loading: false,
		email_verified: false,
		alert: {
			show: false,
			message: "test",
			type: "primary",
		},
	},
	getters: {
		logged_in(state)
		{
			return state.token != null; // Not using !==
		},

		role(state)
		{
			if(state.user.is_rfc){
				return "rfc";
			}
			else if (state.user.is_mentor) {
				return "mentor";
			}
			else if (state.user.is_mentee) {
				return "mentee";
			}

			return null;
		}
	},
	mutations: {
		set_token(state, token)
		{
			localStorage.setItem("rmp_token", token);
			state.token = token;
		},

		set_user(state, data)
		{
			// TODO Logout and redirect to 'Home' if this is the case
			// if (state.is_mentor === state.is_mentee) {}

			localStorage.setItem("rmp_user", JSON.stringify(data)); // Stringify is needed
			state.user = {...data};
		},

		update_token(state, token)
		{
			state.token_token = token;
		},

		destroy_token(state)
		{
			state.token = null;
			localStorage.removeItem("rmp_token");
		},

		destroy_user(state)
		{
			state.user = {};
			localStorage.removeItem("rmp_user");
		},

		set_show_loading(state, value)
		{
			state.show_loading = value;
		},

		set_email_verified(state, value)
		{
			state.email_verified = value;
		},
		
		set_show_alert(state, message)
		{
			state.alert.show = message.show;
			state.alert.message = message.message;
			state.alert.type = message.type;
		},
	},
	actions: {
		logout_user(context)
		{
			context.commit("destroy_token");
			context.commit("destroy_user");
		}
	},
	modules: {

	}
});

export default store;
